import graphqlClient from 'ppbl/graphql/graphqlClient'
import { getCreditApplicationDataQuery } from './queries'

export const updateApplicationCachedData = (newData, prevData) => {
  return graphqlClient.writeQuery({
    query: getCreditApplicationDataQuery,
    data: {
      ...prevData,
      ...newData,
    },
  })
}
